import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLocalizedPath } from '../i18nLanguages';
import { MOBILE_MEDIA_QUERY } from '../constants/breakpoints';

const getLocalizedTo = (to, pathname) => {
  if (typeof to === 'string') return getLocalizedPath(to, pathname);

  if (to && typeof to === 'object' && to.pathname) {
    return {
      ...to,
      pathname: getLocalizedPath(to.pathname, pathname),
    };
  }

  return to;
};

const useLocalizedNavigate = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return useCallback(
    (to, options) => {
      if (typeof to === 'number') {
        navigate(to);
        return;
      }

      // { newTab: true } opens the page in a new browser tab instead, except on
      // phones and the installed app, where a new tab loses the app context.
      if (
        options?.newTab &&
        !window.matchMedia(MOBILE_MEDIA_QUERY).matches &&
        !window.matchMedia('(display-mode: standalone)').matches
      ) {
        window.open(getLocalizedPath(to, pathname), '_blank');
        return;
      }

      navigate(getLocalizedTo(to, pathname), options);
    },
    [navigate, pathname]
  );
};

export default useLocalizedNavigate;
